<template>
	<div class="wrapper">
		<input :id="id" class="exp" type="checkbox" @click.stop />
		<div class="text">
			<label :class="['btn', id]" :for="id" @click.self="$emit('toggleExpandsCollapses')">
				<i class="btn__icon" v-if="$slots.icon">
					<slot name="icon" />
				</i>
				<van-icon v-else class="btn__icon" name="arrow-down" size="12px" />
			</label>
			{{ content }}
		</div>
	</div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      default: ""
    }
  },
};
</script>

<style scoped>

.wrapper {
  --color-primary: #f7443f;
}

.wrapper {
	display: flex;
	overflow: hidden;
	height: fit-content;
	line-height: 18px;
	/* resize: horizontal; */
}
.text {
	overflow: hidden;
	text-overflow: ellipsis;
	text-align: justify;
  /* webkit内核-兼容现代浏览器 */
	/* display: -webkit-box; */
	/* -webkit-line-clamp: v-bind(lineNum); */
	/* -webkit-box-orient: vertical; */

  /* 全兼容方案 */
	position: relative;
	max-height: calc(18px * 3);
	transition: 0.3s max-height;
}
.text::before {
	content: "";
  height: calc(100% - 18px);
	float: right;
}
.text::after {
	content: "";
	width: 999vw;
	height: 999vw;
	position: absolute;
	/* 使用内阴影遮盖为满足溢出容器显示展开收起时，其后面显示的查看全部和收起按钮 */
	/* 展开收起按钮始终都会存在，使用这种方式来让和容器背景同样的颜色值来遮盖文字，就算用户点到了隐藏的按钮也不会触发任何动作，只是单纯的切换了一次按钮 */
	box-shadow: inset calc(100px - 999vw) calc(18px - 999vw) 0 0 #fff;
	/* -100px 为展开收起与省略号(...) 的占位空间 */
	margin-left: -100px;
}
.btn {
	position: relative;
	float: right;
	clear: both;
	margin-left: 20px;
	padding-left: 8px;
	color: var(--color-primary);
	cursor: pointer;
}
.btn::after {
	content: "展开";
}
.exp {
	display: none;
}
.exp:checked + .text::after {
	visibility: hidden;
}
.exp:checked + .text .btn::before {
	visibility: hidden;
}
.exp:checked + .text .btn::after {
	content: "收起";
	/* 收起时可能文本没有对齐，所以手动定位微调
   position: relative;
  top: -2px; */
}
.btn::before {
	content: "...";
	position: absolute;
	left: -5px;
	color: #999;
	transform: translateX(-100%);
	/* line-height: 1em; */
}

.exp:checked + .text {
	max-height: 100vh; /*超出最大行高度就可以了 */
	-webkit-line-clamp: 99999;
}


/* icon */
.exp:checked + .text .btn__icon {
	transform: rotateZ(-180deg);
}

.btn__icon {
	float: right;
	margin-top: 1px;
	transform: rotateZ(0deg);
	transition: transform 0.3s;
	line-height: 16px;
	margin-left: 2px;
}

i.btn__icon {
	font-style: normal;
}
</style>
